import React from 'react';
import {
  Box, FormControl, InputLabel, Select, MenuItem,
  Chip, Autocomplete, TextField, Checkbox,
} from '@mui/material';
import type { SwimmingSettings } from '@/types';
import type { SportSettingsFormProps } from './types';
import { SettingsSection } from './SettingsSection';
import { SettingsField, SettingsFieldsGrid } from './SettingsFieldsGrid';

const POOL_OPTIONS = [
  { value: 'long_course_50',  label: 'Длинная вода (50 м)' },
  { value: 'short_course_25', label: 'Короткая вода (25 м)' },
  { value: 'open_water',      label: 'Открытая вода' },
] as const;

const TIEBREAKER_OPTIONS = [
  { value: 'time',             label: 'Время' },
  { value: 'qualifying_time',  label: 'Квалификационное время' },
  { value: 'drawing_lots',     label: 'Жребий' },
] as const;

export const SwimmingSettingsForm: React.FC<SportSettingsFormProps> = ({ value, onChange, disabled }) => {
  const s = value as SwimmingSettings;
  const upd = (patch: Partial<SwimmingSettings>) => onChange({ ...s, ...patch });

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>

      <SettingsSection title="Бассейн">
        <SettingsFieldsGrid>
          <SettingsField fullWidth>
            <FormControl size="small" fullWidth disabled={disabled}>
              <InputLabel>Тип бассейна</InputLabel>
              <Select
                value={s.pool ?? 'long_course_50'}
                label="Тип бассейна"
                onChange={(e) => upd({ pool: e.target.value as SwimmingSettings['pool'] })}
              >
                {POOL_OPTIONS.map((o) => (
                  <MenuItem key={o.value} value={o.value}>{o.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
          </SettingsField>
        </SettingsFieldsGrid>
      </SettingsSection>

      <SettingsSection title="Тай-брейки">
        <Autocomplete
          multiple
          disableCloseOnSelect
          options={TIEBREAKER_OPTIONS.map((o) => o.value)}
          value={s.tieBreakers ?? []}
          onChange={(_, v) => upd({ tieBreakers: v as SwimmingSettings['tieBreakers'] })}
          getOptionLabel={(o) => TIEBREAKER_OPTIONS.find((x) => x.value === o)?.label ?? o}
          disabled={disabled}
          renderOption={(props, option, { selected }) => (
            <li {...props}>
              <Checkbox checked={selected} size="small" sx={{ mr: 1 }} />
              {TIEBREAKER_OPTIONS.find((x) => x.value === option)?.label ?? option}
            </li>
          )}
          renderTags={(val, getTagProps) =>
            val.map((opt, idx) => (
              <Chip label={`${idx + 1}. ${TIEBREAKER_OPTIONS.find((x) => x.value === opt)?.label ?? opt}`}
                size="small" {...getTagProps({ index: idx })} key={opt} />
            ))
          }
          renderInput={(params) => <TextField {...params} size="small" fullWidth placeholder="Добавить критерий..." />}
        />
      </SettingsSection>

    </Box>
  );
};
